import vars from '../helpers';
import analytics from './analytics';

const dataPages = window.data.pages;
const titles = {};
const descriptions = {};

let escEvent = true;
let $popupAreas = null;
let $btnPopupOpen = null;

Object.entries(dataPages).forEach(([key, value]) => {
	titles[key] = value.title;
	descriptions[key] = value.description;
});

function setMeta(title, description) {
	document.title = title;
	$('meta[name="description"]').attr('content', description);
}

function close(e, container) {
	escEvent = false;

	const $popup = container.querySelector('.popup.is-active');
	const $popupJQ = $($popup).find('.popup__inner');
	const $popupId = $popup.id;

	$popup.classList.remove('is-active');
	vars.lockScroll(false, $popupJQ, 'popup');
	vars.scrollTo($(`.section-${$popupId}`), 10, 1);
	history.pushState(null, null, `${vars.globalPath}${location.search}`);
	setMeta(titles.home, descriptions.home);
	$popupJQ.scrollTop(0);
}

function handlerPopupCloseEsc(e, container) {
	if (e.keyCode === 27 && escEvent) {
		close(e, container);
	}
}

function open(url, container) {
	escEvent = true;

	const popupUrl = url;
	const popupId = popupUrl.replace('#', '');
	const $popup = container.querySelector(`#${popupId}`);
	const $popupJQ = $(`#${popupId}`).find('.popup__inner');

	history.pushState(null, null, `${vars.globalPath}${popupId}/${location.search}`);
	setMeta(titles[popupId], descriptions[popupId]);
	vars.lockScroll(true, $popupJQ, 'popup');

	const ymOptions = {
		referer: vars.filterPath(location.href),
		title: document.title,
	};

	analytics.ymHit(undefined, ymOptions);

	$popup.classList.add('is-active');

	window.addEventListener('keydown', (e) => handlerPopupCloseEsc(e, container), {
		once: true,
	});
}

function detectUrl(container) {
	if (vars.getUrlPath()) {
		const popupUrl = vars.getUrlPath().replace('/', '');

		open(popupUrl, container);
	}
}

function handler(e, container) {
	e.preventDefault();

	const popupUrl = e.currentTarget.getAttribute('href');
	const $popup = container.querySelector('.popup.is-active');
	const $popupJQ = $($popup).find('.popup__inner');

	if (e.currentTarget.closest('.player--full')) {
		$popupJQ.stop().animate({
			scrollTop: 0,
		}, 500);
	} else {
		open(popupUrl, container);
	}
}

function handlerPopupClose(e, container) {
	const $popupClose = e.target.closest('.popup__close');

	if ($popupClose) {
		close(e, container);
	}
}

function init(container) {
	detectUrl(container);

	$btnPopupOpen = container.querySelectorAll('.js-popup-open');
	$popupAreas = container.querySelectorAll('.popup__area');

	$btnPopupOpen.forEach((btn) => {
		btn.addEventListener('click', (e) => handler(e, container));
	});

	$popupAreas.forEach((area) => {
		area.addEventListener('click', (e) => close(e, container));
	});

	window.addEventListener('click', (e) => handlerPopupClose(e, container));
}

function destroy(container) {
	$btnPopupOpen = container.querySelectorAll('.js-popup-open');

	$btnPopupOpen.forEach((btn) => {
		btn.removeEventListener('click', (e) => handler(e));
	});
}

export default {
	init,
	destroy,
};
